import { useEffect, useState } from "react";
import { getMyFeeDetail } from "@/api/profile.api";
import type { MyFeeDetail } from "@/types/profile.types";

interface UseMyFeeDetailResult {
  fee: MyFeeDetail | null;
  isLoading: boolean;
  error: Error | null;
}

export function useMyFeeDetail(id: number | null): UseMyFeeDetailResult {
  const [fee, setFee] = useState<MyFeeDetail | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    if (id === null) {
      setFee(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    getMyFeeDetail(id)
      .then((res) => {
        if (!cancelled) setFee(res);
      })
      .catch((e) => {
        if (!cancelled) {
          setFee(null);
          setError(e instanceof Error ? e : new Error(String(e)));
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { fee, isLoading, error };
}
